import './home.css';
import { useContext } from 'react';
import { UserContext } from '../context/UserContext';

export default function Impressum() {
  const { user } = useContext(UserContext);
  return (
    <div className="home-page">
      {/* Hero */}
      <section id="top" className={user ? 'hero-offset-if-sidebar' : ''} style={{ width:'100vw', margin:0, padding:0 }}>
        <h2 className="hero-title" style={{ textAlign: 'center', margin:'0 0 8px' }}>Impressum</h2>
        <p className="hero-desc" style={{ margin:'0 auto 24px', textAlign: 'center', maxWidth:760 }}>Stand: 15.01.2026</p>
      </section>

      <section style={{ width: '100%', maxWidth: 900, margin: '0 auto', padding: '0 16px 40px 16px', color: '#fff' }}>
        {/* Inhalt / Table of Contents */}
        <div className="highlight-card" style={{ padding: 24, marginBottom: 16 }}>
          <h2 className="highlight-title">Inhalt</h2>
          <div style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: 8,
            marginTop: 10
          }}>
            {[
              { href: '#anbieterkennzeichnung', label: 'Anbieterkennzeichnung' },
              { href: '#registerangaben', label: 'Registerangaben' },
              { href: '#verantwortlich', label: 'Verantwortlich' },
              { href: '#verbraucherstreitbeilegung', label: 'Verbraucherstreitbeilegung' },
              { href: '#haftung-inhalte', label: 'Haftung für Inhalte' },
              { href: '#haftung-links', label: 'Haftung für Links' },
              { href: '#urheberrecht', label: 'Urheberrecht' },
              { href: '#bild-markenhinweise', label: 'Bild- & Markenhinweise' },
              { href: '#raeumliche-geltung', label: 'Räumliche Geltung' }
            ].map(btn => (
              <a
                key={btn.href}
                href={btn.href}
                aria-label={`Zum Abschnitt ${btn.label}`}
                style={{
                  fontSize: 12,
                  lineHeight: '18px',
                  padding: '4px 10px',
                  borderRadius: 999,
                  border: '1px solid rgba(50, 205, 137, 0.35)',
                  color: '#d8f5e8',
                  textDecoration: 'none',
                  background: 'rgba(255,255,255,0.02)'
                }}
              >
                {btn.label}
              </a>
            ))}
          </div>
        </div>
        {/* Anbieterkennzeichnung */}
  <div id="anbieterkennzeichnung" className="highlight-card" style={{ padding: 24, marginBottom: 16 }}>
          <h2 className="highlight-title">Anbieterkennzeichnung gemäß § 5 TMG</h2>
          <p className="highlight-desc" style={{ marginTop: 6, marginBottom: 12 }}>
            AP-Network UG (haftungsbeschränkt)
          </p>
          <address style={{ fontStyle: 'normal', lineHeight: 1.6 }}>
            Wittenberger Weg 17<br/>
            24941 Flensburg<br/>
            Deutschland
          </address>
          <p style={{ marginTop: 10 }}>
            E-Mail: <a href="mailto:kontakt@ap-n.de" style={{ color: '#32CD89' }}>kontakt@ap-n.de</a><br/>
            Website: <a href="https://ap-n.de" target="_blank" rel="noreferrer" style={{ color: '#32CD89' }}>ap-n.de</a>
          </p>
          <p className="highlight-desc" style={{ marginTop: 10 }}>
            Geschäftsführer:<br/>
            Alexander Suhling<br/>
            Pierre Gauglitz
          </p>
        </div>

        {/* Registerangaben */}
  <div id="registerangaben" className="highlight-card" style={{ padding: 24, marginBottom: 16 }}>
          <h2 className="highlight-title">Registerangaben</h2>
          <p className="highlight-desc">
            Registergericht: Amtsgericht Flensburg<br/>
            Registernummer: HRB 18026 FL
          </p>
          <p className="highlight-desc" style={{ marginTop: 10 }}>
            Finanzamt: Flensburg<br/>
            Steuernummer: 15/290/40379<br/>
            USt-IdNr. gemäß § 27a UStG: DE459589157
          </p>
        </div>

        {/* Verantwortlich */}
  <div id="verantwortlich" className="highlight-card" style={{ padding: 24, marginBottom: 16 }}>
          <h2 className="highlight-title">Verantwortlich i.S.d. § 18 Abs. 2 MStV</h2>
          <p className="highlight-desc">
            AP-Network UG (haftungsbeschränkt)<br/>
            Wittenberger Weg 17, 24941 Flensburg<br/>
            E-Mail: <a href="mailto:kontakt@ap-n.de" style={{ color: '#32CD89' }}>kontakt@ap-n.de</a>
          </p>
        </div>

        {/* Verbraucherstreitbeilegung */}
  <div id="verbraucherstreitbeilegung" className="highlight-card" style={{ padding: 24, marginBottom: 16 }}>
          <h2 className="highlight-title">Verbraucherstreitbeilegung / OS-Plattform</h2>
          <p className="highlight-desc">
            Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: {' '}
            <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noreferrer" style={{ color: '#32CD89' }}>ec.europa.eu/consumers/odr</a>.
          </p>
          <p className="highlight-desc" style={{ marginTop: 10 }}>
            Wir sind nicht verpflichtet und grundsätzlich nicht bereit, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
          </p>
        </div>

        {/* Haftung für Inhalte */}
  <div id="haftung-inhalte" className="highlight-card" style={{ padding: 24, marginBottom: 16 }}>
          <h2 className="highlight-title">Haftung für Inhalte</h2>
          <p className="highlight-desc">
            Als Diensteanbieter sind wir gemäß § 7 Abs. 1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
          </p>
        </div>

        {/* Haftung für Links */}
  <div id="haftung-links" className="highlight-card" style={{ padding: 24, marginBottom: 16 }}>
          <h2 className="highlight-title">Haftung für Links</h2>
          <p className="highlight-desc">
            Unser Angebot enthält ggf. Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.
          </p>
        </div>

        {/* Urheberrecht */}
  <div id="urheberrecht" className="highlight-card" style={{ padding: 24, marginBottom: 16 }}>
          <h2 className="highlight-title">Urheberrecht</h2>
          <p className="highlight-desc">
            Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet, sofern nicht anders angegeben. Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet und entsprechende Inhalte gekennzeichnet. Solltest du trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen Hinweis. Bei Bekanntwerden von Rechtsverletzungen entfernen wir derartige Inhalte umgehend.
          </p>
        </div>

        {/* Bild- & Markenhinweise */}
  <div id="bild-markenhinweise" className="highlight-card" style={{ padding: 24, marginBottom: 16 }}>
          <h2 className="highlight-title">Bild- & Markenhinweise</h2>
          <p className="highlight-desc">
            Verwendete Medien (Bilder, Grafiken, Logos) sind selbst erstellt. Marken- und Produktnamen sind Eigentum der jeweiligen Rechteinhaber und werden nur zu Identifikationszwecken genutzt.
          </p>
        </div>

        {/* Räumliche Geltung */}
        <div id="raeumliche-geltung" className="highlight-card" style={{ padding: 24 }}>
          <h2 className="highlight-title">Räumliche Geltung</h2>
          <p className="highlight-desc">
            Dieses Impressum gilt für die Domains ap-n.de und ap-network.de sowie ggf. weitere Subdomains oder Präsenzen, sofern von uns betrieben und entsprechend gekennzeichnet.
          </p>
          <div style={{ marginTop: 16 }}>
            <a href="#top" style={{ color: '#32CD89' }}>Nach oben</a>
          </div>
        </div>
      </section>
    </div>
  );
}
